import { useBoolean } from "@/hooks/use-boolean";
import { Button } from "@babackapp/ui/components/button";
import { Table } from "@tanstack/react-table";
import { DownloadIcon } from "lucide-react";
import { useCallback, useMemo } from "react";
import { ExportReturnFieldsProvider } from "../../../hooks/use-export-return-fields-context";
import { SelectExportReturnFieldDialog } from "./select-export-return-field-dialog";

interface DownloadResultsButtonProps<TData> {
  table: Table<TData>;
}

export function DownloadResultsButton<TData>({
  table,
}: DownloadResultsButtonProps<TData>) {
  const modal = useBoolean(false);
  const tableFields = useMemo(() => {
    return table
      .getAllColumns()
      .filter((column) => column.getIsVisible())
      .map((column) => column.id);
  }, [table]);

  const openModal = useCallback(() => {
    modal.setValue(true);
  }, [modal]);

  return (
    <ExportReturnFieldsProvider fieldsAlreadySelected={tableFields}>
      <SelectExportReturnFieldDialog
        open={modal.value}
        openChange={modal.setValue}
      />
      <Button variant="outline" size="sm" onClick={openModal}>
        <DownloadIcon className="size-4" />
      </Button>
    </ExportReturnFieldsProvider>
  );
}
